<template>
  <div class="mask qusetionis" @click.stop="$emit('close')" @touchmove.prevent>
    <div class="container">
      <div class="close" @click="$emit('close')"></div>
      <div class="imgs">
        <div class="scroll-box" @touchmove.stop v-touchmove>
          <slot>
            <img v-for="(item, index) in pics" :key="index" :src="item" @click.stop />
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import导入组件工具等
export default {
  props: {
    pics: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
  // 组件方法
  methods: {},
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // import的组件需要声明
  components: {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.container {
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 920px;
  margin: 0 auto;
  padding: 50px 0;
  .close {
    position: absolute;
    top: 50px;
    right: 6px;
    width: 28px;
    height: 28px;
    cursor: pointer;
    .bg-image('close');
    z-index: 2;
  }
  .imgs {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    overflow-y: auto;
    height: 100%;
    .scroll-box {
      width: 100%;
      max-height: 100%;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      align-items: center;

      &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
        background-color: transparent;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 5px;
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        background-color: rgba(0, 0, 0, 0.2);
      }

      /*定义滑块
      内阴影+圆角*/
      /*  鼠标hover的时候才显示滚动条 */
      &:hover::-webkit-scrollbar-thumb {
        border-radius: 5px;
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        background-color: rgba(0, 0, 0, 0.2);
      }
    }
    img {
      max-width: 300px;
    }
  }
}
</style>
